import React from 'react'

export default function TextInput({ label, value, onChange, type, placeholder, name }) {
	return (
		<div className="w-full">
			<label className="text-[#666666]">{label}</label>
			<div className={`relative w-full text-[#666666] ${label && 'mt-2'}`}>
				<input
					name={name}
					onChange={onChange}
					value={value || ''}
					type={type}
					placeholder={placeholder}
					className="w-full pl-2  pr-3 py-2 appearance-none bg-transparent outline-none border-[2px] text-start border-[#CCCCCC] focus:border-primary shadow-sm rounded-md"
				/>
			</div>
		</div>
	)
}
